import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CowState } from '../../models/cow.model';

export const getCowState = createFeatureSelector<CowState>('cow-shared');

export const getCow = createSelector(getCowState, (state: CowState) => state?.cow);
